<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3
                class="font-weight-bold"
                v-text="isDeletePage() != true ? 'Events' : 'Deleted Events'"
              ></h3>
              <template v-if="isDeletePage() != true">
                <v-btn
                  class="mx-2 mb-2"
                  fab
                  x-small
                  color="primary"
                  to="/events/create"
                >
                  <v-icon dark> mdi-plus </v-icon>
                </v-btn>
              </template>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search ... "
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="status"
                    solo
                    rounded
                    v-model="filter.is_active"
                    :items="statuses"
                    clearable
                    @click:clear="(filter.is_active = null), (page = 1)"
                    label="Status"
                    @input="getData"
                    prepend-inner-icon="mdi-toggle-switch"
                  ></v-autocomplete>
                </v-col>
                <v-col sm="3">
                  <v-autocomplete
                    ref="eventType"
                    solo
                    rounded
                    v-model="filter.event_type"
                    :items="eventTypes"
                    clearable
                    @click:clear="(filter.event_type = null), (page = 1)"
                    label="Event Type"
                    @input="getData"
                    prepend-inner-icon="mdi-calendar-star"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                :height="$vuetify.breakpoint.mobile ? '60vh' : '70vh'"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>&nbsp; Sr. No.</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-left" style="min-width: none">Event Name</th>
                      <th class="text-left" style="min-width: none">Event Type</th>
                      <th class="text-left" style="min-width: none">Start Date</th>
                      <th class="text-left" style="min-width: none">End Date</th>
                      <th class="text-left" style="min-width: none">Participants</th>
                      <th class="text-left" style="min-width: none">Rewards</th>
                      <th class="text-left" style="min-width: none">Claims</th>
                      <th class="text-right">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="events.length != 0">
                    <tr
                      v-for="(event, i) in events"
                      :key="`event_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': events.length - 1 == i,
                      }"
                    >
                      <td>&nbsp;{{ i + 1 }}</td>
                      <td>
                        <v-tooltip bottom v-if="event.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span>Event is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="event.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Event is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ event.name || "" }}
                      </td>
                      <td>
                        <v-chip small :color="getEventTypeColor(event.type)">
                          {{ event.type || "" }}
                        </v-chip>
                      </td>
                      <td>
                        {{ formatDate(event.start_date) }}
                      </td>
                      <td>
                        {{ formatDate(event.end_date) }}
                      </td>
                      <td>
                        <v-chip small color="primary" text-color="white">
                          {{ event.participants_count || 0 }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small color="orange" text-color="white">
                          {{ event.rewards_count || 0 }}
                        </v-chip>
                      </td>
                      <td>
                        <v-chip small color="green" text-color="white">
                          {{ event.claims_count || 0 }}
                        </v-chip>
                      </td>

                      <td class="text-right">
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Delete_this(event.id)"
                              >
                                <v-icon dark> mdi-delete </v-icon>
                              </v-btn>
                            </template>
                            <span>Delete this Event</span>
                          </v-tooltip>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                class="ml-2"
                                fab
                                x-small
                                color="primary"
                                :to="`/events/${encryptIt(event.id)}`"
                              >
                                <v-icon dark> mdi-pencil </v-icon>
                              </v-btn>
                            </template>
                            <span>Edit this Event</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto"
                                color="error"
                                @click="Restore_this(event.id)"
                              >
                                <v-icon dark> mdi-delete-restore </v-icon>
                              </v-btn>
                            </template>
                            <span>Restore this Event</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="9" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Delete Success Dialog Box -->
      <v-dialog v-model="is_deleted_event" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Event deleted successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_deleted_event = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      <!-- Restore Success Dialog Box -->
      <v-dialog v-model="is_restored_event" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-restore
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Event restored successfully.</h3>
                      <br />
                      <v-btn color="success" @click="is_restored_event = false">
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "EventsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        is_active: "",
        event_type: "",
        show_deleted: false,
      },
      events: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      eventTypes: [
        {
          id: 0,
          text: "Select Event Type",
          value: "",
        },
        { id: "HOST", text: "Host Event", value: "host" },
        { id: "AGENCY", text: "Agency Event", value: "agency" },
        { id: "USER", text: "User Event", value: "user" },
        { id: "RECHARGE", text: "Recharge Event", value: "recharge" },
        { id: "RANKING", text: "Ranking Event", value: "ranking" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      delete_event: false,
      is_deleted_event: false,
      restore_event: false,
      is_restored_event: false,
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.event_type = this.filter.event_type
        ? this.filter.event_type
        : "";
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&show_deleted=" +
        this.filter.show_deleted +
        "&is_active=" +
        this.filter.is_active +
        "&event_type=" +
        this.filter.event_type +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`events?${query}`)
        .then((response) => {
          this.events = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
    async Delete_this(id) {
      this.delete_event = true;
      await axios
        .post(`/events/delete/${this.encryptIt(id)}`)
        .then(() => {
          this.delete_event = false;
          this.is_deleted_event = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async Restore_this(id) {
      this.restore_event = true;
      await axios
        .post(`/events/restore/${this.encryptIt(id)}`)
        .then(() => {
          this.restore_event = false;
          this.is_restored_event = true;
          this.getData();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    isDeletePage() {
      let response = false;
      if (this.$route.query.open_trash) {
        response = true;
      }
      return response;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    getEventTypeColor(type) {
      const colors = {
        host: "purple",
        agency: "orange",
        user: "blue",
        recharge: "green",
        ranking: "red",
      };
      return colors[type?.toLowerCase()] || "grey";
    },
  },
};
</script>